<form
    [formGroup]="adviceForm"
    (submit)="submit.emit()"
>
    @if (getAdvice()) {
        <button
            class="btn-link m-32:b"
            (click)="toggleAdvice(false)"
        >
            Ohne Produktberatung fortfahren
        </button>

        @for (q of questionSet(); track q.controlName) {
            <fieldset class="m-24:b">
                <legend class="fw:bold m-16:b">{{ q.question }}</legend>
                @for (option of q.answerOptions; track option.value; let i = $index) {
                    <div class="g-auto">
                        <input
                            type="radio"
                            [id]="q.controlName + '-' + option.value"
                            [formControlName]="q.controlName"
                            [value]="option.value"
                        />
                        <label [attr.for]="q.controlName + '-' + option.value">{{ option.label }}</label>
                    </div>
                }
                @if (q.controlName === 'HANDY_Q1' && adviceForm.get(q.controlName).value !== null) {
                    <div class="bg:grey-5 p-12 md:p-16 lg:p-24 br-3 fs:xs">
                        <p class="fs:l fw:bold">Hinweis für eine reibungslose Abwicklung im Schadensfall:</p>
                        <p class="m-0:b">
                            Melde dich nach einem Schadensfall und vor einer Reparatur zeitnah bei uns und halte die
                            Originalrechnung bereit.
                        </p>
                    </div>
                }
            </fieldset>
        }
    } @else {
        <div class="bg:grey-5 p-12 md:p-16 lg:p-24 border">
            <h4 class="p-12:b fw:bold c:blue-1">Ohne Produktberatung fortfahren</h4>
            <p>
                Du möchtest die Versicherung ohne Ermittlung deiner Wünsche und Bedürfnisse sowie ohne Beratung
                abschließen. Ein solcher Verzicht kann sich nachteilig auf die Möglichkeit auswirken, gegen den
                Versicherer einen Schadensersatzanspruch wegen Verletzung von Beratungs- und Dokumentationspflichten
                geltend zu machen.
            </p>
            <input
                type="checkbox"
                id="check-no-advice"
                formControlName="waiverConfirmed"
            />
            <label for="check-no-advice"
                >Ich bestätige den Beratungsverzicht und möchte ohne Produktberatung fortfahren.</label
            >
            <div class="grid-container -two-buttons m-0">
                <button
                    class="btn-link"
                    (click)="toggleAdvice(true)"
                >
                    Zurück zur Produktberatung
                </button>
                <button
                    type="submit"
                    class="-width-auto"
                    [disabled]="adviceForm.invalid"
                >
                    Verzicht bestätigen
                </button>
            </div>
        </div>
    }
</form>
